import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_form_field_scheduled_price_month = _resolveComponent("form-field-scheduled-price-month")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_input, {
      class: "col q-pr-md",
      rules: [_ctx.numberOnlyRule, _ctx.nonNegativeRule],
      "hide-bottom-space": "",
      outlined: "",
      dense: "",
      modelValue: _ctx.localModel.price,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModel.price) = $event)),
      modelModifiers: { number: true },
      label: "Price",
      type: "number",
      min: "min"
    }, {
      append: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.currency), 1)
      ]),
      _: 1
    }, 8, ["rules", "modelValue"]),
    _createVNode(_component_form_field_scheduled_price_month, {
      modelValue: _ctx.localModel.validFrom,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.validFrom) = $event)),
      "start-date": _ctx.validFromOptionsStartDate.toDate(),
      "end-date": _ctx.validFromOptionsEndDate.toDate(),
      interval: _ctx.currentAgreement.invoicingPeriod,
      "invoicing-from": _ctx.currentAgreement.invoiceAllowedFrom,
      "validation-rules": [_ctx.requiredRule, _ctx.dateNotScheduledAlreadyValidator],
      "onScheduledPrices:revalidateForm": _ctx.itemChanged
    }, null, 8, ["modelValue", "start-date", "end-date", "interval", "invoicing-from", "validation-rules", "onScheduledPrices:revalidateForm"])
  ], 64))
}